import React, { useState, useEffect } from "react";
import { useAuth } from "../../hook/userAuth";
import estilo from "./Profile.module.css";
import { Button, Icon } from "semantic-ui-react";
import ModalBasic from "../../components/ModalBasic/ModalBasic";
import { UpdateProfile } from "./UpdateProfile/UpdateProfile";
import axios from "axios";
import { BASE_API } from "../../ruta-server/BaseApi";

export default function Profile() {
  const { auth } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState(null);
  const [contentModal, setContentModal] = useState(null);
  const [refetch, setRefetch] = useState(false);
  const [user, setUser] = useState(null);

  const openCloseModal = () => setShowModal((prev) => !prev);

  const renderName = () => {
    if (auth?.me?.first_name && auth?.me?.last_name) {
      return `${auth?.me.first_name} ${auth?.me.last_name} ${auth?.me.apellido_materno}`;
    }
    return auth?.me?.email;
  };

  const getInitials = () => {
    if (auth?.me?.first_name && auth?.me?.last_name) {
      const firstNameInitial = auth.me.first_name.charAt(0);
      const lastNameInitial = auth.me.last_name.charAt(0);
      return `${firstNameInitial}${lastNameInitial}`.toUpperCase();
    }
    return "";
  };

  async function getMeApi() {
    try {
      const response = await axios.get(`${BASE_API}/api/auth/me/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const result = response.data;
      setUser(result);
      return result;
    } catch (error) {
      window.location.reload();
      window.location.href = "/Login";
      throw error;
    }
  }

  useEffect(() => {
    getMeApi();
    // eslint-disable-next-line
  }, [refetch]);

  const onRefetch = () => {
    setRefetch((prev) => !prev);
  };

  const updateUser = () => {
    setTitleModal("Actualizar datos");
    setContentModal(
      <UpdateProfile
        onClose={openCloseModal}
        onRefetch={onRefetch}
        user={user}
      />
    );
    openCloseModal();
  };

  return (
    <div>
      <div>
        <h1 className="tituloin">Perfil</h1>
      </div>

      <div className={estilo.cuadro}>
        <div className={estilo.headerpa}>
          <Button circular icon className={estilo.ico}>
            {getInitials()}
          </Button>

          <Button
            onClick={updateUser}
            className={estilo.btonAc}
            title="Actualizar datos"
          >
            <Icon name="pencil" style={{ color: "white" }}></Icon>
          </Button>
        </div>
        <div className={estilo.datos}>
          <ul>
            <li>
              <h3>{renderName()} </h3>
            </li>
            <li>
              <small> CURP: </small>
              <span>{user?.curp} </span>
            </li>
            <li>
              <small> Correo: </small>
              <span>{user?.email} </span>
            </li>
            <li>
              <small> Teléfono: </small>
              <span>{user?.telefono} </span>
            </li>

            {user?.es_docente ||
              (user?.is_superuser && (
                <li>
                  <small> Categoria: </small>
                  <span>{user?.categoria} </span>
                </li>
              ))}
            {user?.es_docente ||
              (user?.is_superuser && (
                <li>
                  <small> Grado de estudios: </small>
                  <span>{user?.grado_estudio} </span>
                </li>
              ))}
          </ul>
        </div>

        <ModalBasic
          show={showModal}
          title={titleModal}
          children={contentModal}
          close={openCloseModal}
        />
      </div>
    </div>
  );
}
